// directive
//   <scoreboard-link-status linked="linked" rssi="rssi" />
//
angular.module('app.directives').component('scoreboardLinkStatus', {
  restrict: 'E',
  bindings: {
    linked: '=',
    rssi: '=',
  },
  template: require('./scoreboard-link-status.html'),
  controllerAs: 'vm',
  controller: function ScoreboardDiagnosticsStatusController($scope, $sce) {
    'ngInject';

    // convert dBm to a number between 0 and 1. This is based on some BoxCaster code:
    // https://github.com/boxcast/boxcaster/blob/master/lib/platform-specific/bc4k/wifi_config.rb#L250-L258
    const dbmToPercent = (dbm) =>
      dbm >= 0.0
        ? 1.0
        : _.min([_.max([0.982 - 0.00379 * dbm + -0.000154 * Math.pow(dbm, 2), 0.0]), 1.0]);

    const recalculate = () => {
      this.signalStrengthPercent = dbmToPercent(this.rssi);
      if (this.signalStrengthPercent < 0.25) {
        this.faClass = 'text-danger';
      } else if (this.signalStrengthPercent < 0.5) {
        this.faClass = 'text-warning';
      } else if (this.signalStrengthPercent < 0.75) {
        this.faClass = 'text-success opacity-80';
      } else {
        this.faClass = 'text-success';
      }
      this.tooltipHTML = $sce.trustAsHtml(
        `${Math.round(100 * this.signalStrengthPercent)}%<br/>(${Math.round(this.rssi)} dBm)`
      );
    };
    $scope.$watchGroup(['linked', 'rssi'], recalculate);
    recalculate();
  },
});



// WEBPACK FOOTER //
// ./app/directives/scoreboard-link-status.js